<template>
  <div class="TheHeader">
    <img src="~@/assets/logo.png" alt="">
    <h1>administration - <span class="TheHeader__logout" @click="logout">déconnexion</span></h1>
  </div>
</template>

<script>
export default {
  name: 'TheHeader',
  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/auth/login');
      });
    },
  },
};
</script>

<style lang="scss">
  .TheHeader {
    position: relative;
    padding: 1em;
    display: flex;
    padding-left: calc(150px + 3em);
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      position: relative;
      margin-right: 1em;
    }
    &__logout {
      cursor: pointer;
      text-decoration: underline;
    }
  }
</style>
